import '../App.css';
import * as React from 'react';
import { NavLink, useParams } from "react-router-dom";

export default function Trophy() {

  const { category } = useParams();
  const { metal } = useParams();

  // Checking to see that the trophy exists

  const [trophyImage, setTrophyimage] = React.useState()

  React.useEffect(() => {
    try{
      const tryImage = require(`../Assets/Images/${category.charAt(0).toUpperCase() + category.slice(1)}${metal.charAt(0).toUpperCase() + metal.slice(1)}.png`)
      setTrophyimage(tryImage)
    } catch {
      const tryImage = require(`../Assets/Images/trivialmania.png`)
      setTrophyimage(tryImage)
    }

  }, [category, metal])

  //Language settings

  const [language] = React.useState(
    () => JSON.parse(window.localStorage.getItem('language')) ?? "English"
  )

  React.useEffect(() => {
    window.localStorage.setItem('language', JSON.stringify(language))
  }, [language])

  // color settings

  const [color] = React.useState(
    () => JSON.parse(window.localStorage.getItem('color')) ?? "#36454F"
  )

  React.useEffect(() => {
    window.localStorage.setItem('color', JSON.stringify(color))
  }, [color])


  //Quotes

  const [quotes, setQuotes] = React.useState(
    () => JSON.parse(window.localStorage.getItem('quotes')) ?? ["TrivialMania is fun."]
  )

  const [quotesEs, setQuotesEs] = React.useState(
    () => JSON.parse(window.localStorage.getItem('quotesEs')) ?? ["TrivialMania mola."]
  )

  //fetch all the data

  React.useEffect(() => {
    if ((window.localStorage.getItem('questions') === null || window.localStorage.getItem('questions') === 'null') && language === 'English'){
      fetch('/.netlify/functions/app/api/questions', {
        headers: {
          'authorization': process.env.REACT_APP_AUTH
        }
      })
      .then((response) => response.json()
      .then((response) => {
        const quo = response.slice(560, 660)
        setQuotes(quo)
      })
      .catch((error) => console.log(error))
    )
    }
  }, [language])

  React.useEffect(() => {
    if ((window.localStorage.getItem('questionsEs') === 'null' || window.localStorage.getItem('questionsEs') === null) && language === 'Spanish'){
      fetch('/.netlify/functions/app/api/questionsEs', {
        headers: {
          'authorization': process.env.REACT_APP_AUTH
        }
      })
      .then((response) => response.json()
      .then((response) => {
        const quo = response.slice(560, 660)
        setQuotesEs(quo)
      })
      .catch((error) => console.log(error))
    )
    }
  }, [language])

  React.useEffect(() => {
    window.localStorage.setItem('quotes', JSON.stringify(quotes))
  }, [quotes])

  React.useEffect(() => {
    window.localStorage.setItem('quotesEs', JSON.stringify(quotesEs))
  }, [quotesEs])

  //Constants to sort quotes

  const sortedQuotes = quotes.sort(() => 0.5 - Math.random())
  const sortedQuotesEs = quotesEs.sort(() => 0.5 - Math.random())

  //Constants for trophy text

  const trophyText = category + metal

  // Geography text

  const geographygold = "Achieved by answering 150 Geography questions correctly!"
  const geographygoldEs = "Conseguido al responder 150 preguntas de Geografía correctamente!"
  const geographysilver = "Achieved by answering 50 Geography questions correctly!"
  const geographysilverEs = "Conseguido al responder 50 preguntas de Geografía correctamente!"
  const geographybronze = "Achieved by answering 10 Geography questions correctly!"
  const geographybronzeEs = "Conseguido al responder 10 preguntas de Geografía correctamente!"

  // History text

  const historygold = "Achieved by answering 70 History questions correctly!"
  const historygoldEs = "Conseguido al responder 70 preguntas de Historia correctamente!"
  const historysilver = "Achieved by answering 30 History questions correctly!"
  const historysilverEs = "Conseguido al responder 30 preguntas de Historia correctamente!"
  const historybronze = "Achieved by answering 10 History questions correctly!"
  const historybronzeEs = "Conseguido al responder 10 preguntas de Historia correctamente!"

  // Entertainment text

  const entertainmentgold = "Achieved by answering 90 Entertainment questions correctly!"
  const entertainmentgoldEs = "Conseguido al responder 90 preguntas de Entretenimiento correctamente!"
  const entertainmentsilver = "Achieved by answering 40 Entertainment questions correctly!"
  const entertainmentsilverEs = "Conseguido al responder 40 preguntas de Entretenimiento correctamente!"
  const entertainmentbronze = "Achieved by answering 10 Entertainment questions correctly!"
  const entertainmentbronzeEs = "Conseguido al responder 10 preguntas de Entretenimiento correctamente!"

  // Art text

  const artgold = "Achieved by answering 90 Art & Literature questions correctly!"
  const artgoldEs = "Conseguido al responder 90 preguntas de Arte y Literatura correctamente!"
  const artsilver = "Achieved by answering 40 Art & Literature questions correctly!"
  const artsilverEs = "Conseguido al responder 40 preguntas de Arte y Literatura correctamente!"
  const artbronze = "Achieved by answering 10 Art & Literature questions correctly!"
  const artbronzeEs = "Conseguido al responder 10 preguntas de Arte y Literatura correctamente!"

  // Science text

  const sciencegold = "Achieved by answering 50 Science & Nature questions correctly!"
  const sciencegoldEs = "Conseguido al responder 50 preguntas de Ciencias y Naturaleza correctamente!"
  const sciencesilver = "Achieved by answering 30 Science & Nature questions correctly!"
  const sciencesilverEs = "Conseguido al responder 30 preguntas de Ciencias y Naturaleza correctamente!"
  const sciencebronze = "Achieved by answering 10 Science & Nature questions correctly!"
  const sciencebronzeEs = "Conseguido al responder 10 preguntas de Ciencias y Naturaleza correctamente!"

  // Score text

  const scoregold = "Achieved a minimum score of 18!"
  const scoregoldEs = "Conseguido al alcanzar una puntuación mínima de 18!"
  const scoresilver = "Achieved a minimum score of 12!"
  const scoresilverEs = "Conseguido al alcanzar una puntuación mínima de 12!"
  const scorebronze = "Achieved a minimum score of 6!"
  const scorebronzeEs = "Conseguido al alcanzar una puntuación mínima de 6!"

  // NumberOne text

  const numberone = "Achieved by unlocking all trophies!"
  const numberoneEs = "Conseguido al desbloquear todos los trofeos!"


  return (
    <div className="App" style={{ backgroundColor: color }}>

    <div className="center" style={{ display: "flex", backgroundColor: color, zIndex: "1", width: "100%", height: "100%", justifyContent: "center", alignItems: "center", textAlign: "center", color: "white"  }}>
    <div alt="Trophy info" style={{ display: "flex", zIndex: "1", justifyContent: "center", alignItems: "center", width: "50%", height: "50%", textAlign: "center", color: "white" }}>

    <div alt="Trophy info">

    <h1>{language === "English" ? "Trophy Information" : "Información del Trofeo"}</h1>

    <img className="badgeInfo" src={ trophyImage } alt="badge" />

    <p>
    {language === "English" && trophyText === "geographygold" ? geographygold : language === "Spanish" && trophyText === "geographygold" ? geographygoldEs : language === "English" && trophyText === "geographysilver" ? geographysilver : language === "Spanish" && trophyText === "geographysilver" ? geographysilverEs : language === "English" && trophyText === "geographybronze" ? geographybronze : language === "Spanish" && trophyText === "geographybronze" ? geographybronzeEs : language === "English" && trophyText === "historygold" ? historygold : language === "Spanish" && trophyText === "historygold" ? historygoldEs : language === "English" && trophyText === "historysilver" ? historysilver : language === "Spanish" && trophyText === "historysilver" ? historysilverEs : language === "English" && trophyText === "historybronze" ? historybronze : language === "Spanish" && trophyText === "historybronze" ? historybronzeEs : language === "English" && trophyText === "entertainmentgold" ? entertainmentgold : language === "Spanish" && trophyText === "entertainmentgold" ? entertainmentgoldEs : language === "English" && trophyText === "entertainmentsilver" ? entertainmentsilver : language === "Spanish" && trophyText === "entertainmentsilver" ? entertainmentsilverEs : language === "English" && trophyText === "entertainmentbronze" ? entertainmentbronze : language === "Spanish" && trophyText === "entertainmentbronze" ? entertainmentbronzeEs : language === "English" && trophyText === "artgold" ? artgold : language === "Spanish" && trophyText === "artgold" ? artgoldEs : language === "English" && trophyText === "artsilver" ? artsilver : language === "Spanish" && trophyText === "artsilver" ? artsilverEs : language === "English" && trophyText === "artbronze" ? artbronze : language === "Spanish" && trophyText === "artbronze" ? artbronzeEs : language === "English" && trophyText === "sciencegold" ? sciencegold : language === "Spanish" && trophyText === "sciencegold" ? sciencegoldEs : language === "English" && trophyText === "sciencesilver" ? sciencesilver : language === "Spanish" && trophyText === "sciencesilver" ? sciencesilverEs : language === "English" && trophyText === "sciencebronze" ? sciencebronze : language === "Spanish" && trophyText === "sciencebronze" ? sciencebronzeEs : language === "English" && trophyText === "scoregold" ? scoregold : language === "Spanish" && trophyText === "scoregold" ? scoregoldEs : language === "English" && trophyText === "scoresilver" ? scoresilver : language === "Spanish" && trophyText === "scoresilver" ? scoresilverEs : language === "English" && trophyText === "scorebronze" ? scorebronze : language === "Spanish" && trophyText === "scorebronze" ? scorebronzeEs : language === "English" && trophyText === "numberone" ? numberone : language === "Spanish" && trophyText === "numberone" ? numberoneEs : "Error!" }
    </p>

    <p>
    {language === "English" ? sortedQuotes[0].quote : sortedQuotesEs[0].quote}
    </p>

    <nav>

    <NavLink to="/trophy" className="button" alt="Trophies" style={{ width: "90%", margin: "5%", marginBottom: "20px" }}>🏆</NavLink>

    </nav>


     </div>
     </div>
     </div>

    </div>
  );
}
